import is from "@core/comparators/is";
import { IItemKey, ITreeItem, Many } from "@core/stdx/util/array";
import {
    concat as concatFn,
    difference as differenceFn,
    intersection as intersectionFn,
    remove as removeFn,
} from "lodash-es";

export namespace array {

  /**
   * @description: 将数组转换为树对象
   * @param {Array} arr 数组
   * @param {IItemKey} idKey 节点的id键值
   * @param {IItemKey} parentKey 节点的parent键值
   * @return {*}
   */
  export function toTreeObject<T>(arr: Array<{ [key: string]: any }>, idKey: IItemKey = "id", parentKey: IItemKey = "parentId"): ITreeItem<T>[] {
    if (!is.array(arr)) {
      return [];
    }

    return createTree(arr, idKey, parentKey);
  }

  function createTree<T>(arr: { [key: string]: any }[], idKey: IItemKey, parentKey: IItemKey): ITreeItem<T>[] {
    const tree: ITreeItem<T>[] = [];

    const mapArr: { [key: IItemKey]: any } = {};

    arr.forEach(el => {
      const elId: IItemKey = el[idKey];

      mapArr[elId] = el;
      mapArr[elId].children = [];
    })

    arr.forEach((elem) => {
      const mapElem = mapArr[elem[idKey]];

      if (elem[parentKey]) {
        mapArr[elem[parentKey]].children.push(elem);
      } else {
        tree.push(mapElem);
      }
    });

    return tree;
  }


  /**
   * 将多个数组连接在一起
   * @param values
   */
  export function concat<T>(...values: Array<Many<T>>): T[] {
    return concatFn<T>(...values);
  }

  /**
   * 删除数组中元素
   * @param values
   */
  export function remove<T>(arr: T[], predicate: (value: T, index: number, list: T[]) => boolean): T[] {
    return removeFn<T>(arr, predicate);
  }

  /**
   * NOTE - 根据条件查找，返回所有符合条件的元素
   * @param values
   * @param fn
   */
  export function query<T>(values: Array<T>, fn: (node: T) => boolean): Array<T> {
    let results: Array<T> | null = [];
    if (values.length > 0 && fn instanceof Function) {
      for (let i = 0; i < values.length; i++) {
        let item = values[i];
        if (fn(item)) {
          results.push(item);
        }
      }
    }
    return results;
  }

  /**
   * NOTE - 传入两个数组,和对比函数,得到newArray数组中不同于oldArray数组的元素，返回这个元素和这些元素对应的Index
   * @param newArray
   * @param oldArray
   * @param compareFunc
   */
  export function findDifferentElements<T>(newArray: T[], oldArray: T[] | Array<any>, compareFunc: (newData: T, oldData: T | any) => boolean): Array<{ data: T, index: number }> | null {
    if (newArray && oldArray && newArray.length > 0 && oldArray.length > 0 && compareFunc instanceof Function) {
      return newArray.reduce((differentItems, data, index) => {
        if (!oldArray.some(element => compareFunc(data, element))) {
          differentItems.push({ data, index });
        }
        return differentItems;
      }, [] as Array<{ data: T, index: number }>);
    }
    return null;
  }

}
